import React, { useCallback, useMemo } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Dialog, Icon, Spinner } from '@blueprintjs/core'
import { globalOnDemandVars } from '../../helper/context'
import { css as classname } from 'emotion'
import { hasScrollbarAlways } from '../../helper/CSSclasses'
import LoadableVisibility from 'react-loadable-visibility/react-loadable'
import ErrorBoundary from './errorBoundary'
// import '../../css/blueprint-overwirte.css'
import { defer } from 'lodash'

const LoadingForDialog = ({ pastDelay, error, timedOut }) => {
  if (error) {
    return <div>error</div>
  } else if (timedOut) {
    return <div>timeOut</div>
  } else if (pastDelay) {
    return <Spinner size={70} intent={'primary'} css={css`top: calc(40% - 35px); left: calc(50% - 35px); position: absolute;`} />
  } else {
    return null
  }
}

const WrapperForLoader = LoadableVisibility({
  loader: () => import('../../helper/WrapperForLoader'),
  loading: LoadingForDialog,
  delay: 100
})

function DialogComp ({ isOpen, title, children, setDialogOpen, type, width100 }) {
  const configs = useMemo(() => {
    let width, height, paddingValue
    switch (type) {
      case 'bigger':
        width = 90
        height = 90
        paddingValue = 0
        break
      default:
        width = 50
        height = 70
        paddingValue = 'var(--s0)'
    }

    return {
      width, height, paddingValue
    }
  }, [type])

  const onClosed = useCallback(
    () => {
      globalOnDemandVars.focusToWindow() && globalOnDemandVars.focusToWindow()()
    }
    ,
    []
  )
  const onClose = useCallback(
    () => { setDialogOpen(false) },
    [setDialogOpen]
  )
  return (
    <ErrorBoundary>
      <Dialog isOpen={isOpen} isCloseButtonShown={false} title={title || null}
        css={css`width: ${configs.width}vw; height: ${configs.height}vh; background-color: var(--sidebarColor) !important; padding: var(--s0); border-radius: 1em; position: relative;
& .bp3-dialog-header {
  border-top-left-radius: 1em; border-top-right-radius: 1em;
  background-color: var(--sidebarColor);
  box-shadow: none;
}
}
`}
        enforceFocus={false} transitionDuration={150} onClosed={onClosed} onClose={onClose}
        backdropClassName={classname`opacity: 0.1 !important;`}
      >
        <Button minimal icon={<Icon icon={'cross'} color={'var(--gray4)'} />} css={css`position: absolute; top: 0; right: 0; z-index: 10;`} onClick={() => {
          onClose()
          defer(onClosed)
        }} />

        <div className={'bp3-dialog-body'}
          css={css`overflow: auto; width: 100%; position: relative; margin: 0 auto 1em auto; border-bottom-left-radius: 1em; border-bottom-right-radius: 1em; background-color: var(--sidebarColor);`}>
          <div css={css`overflow: visible; margin: 0 auto 0 auto; background-color: var(--baseColor); border-radius: 1em; padding: ${configs.paddingValue}; height: calc(100% - 4px); width: 100%;`}>
            <WrapperForLoader content={children} />
          </div>
        </div>
      </Dialog>
    </ErrorBoundary>
  )
}

export default DialogComp
